/**
 * Conversion Composable
 * S2S 轉換追蹤送出(vendor-neutral,規格見 s2s-conversion-portable-spec)
 *
 * 架構:
 * - 單例模式:使用 nuxtApp._conversionContext 避免 sender 重複創建
 * - 純邏輯在 utils/conversionSender.js(DI 工廠,可單測),此處只做 Nuxt 接線
 * - raw fetch 繞過 $request 攔截器:背景追蹤失敗絕不可觸發全域錯誤 modal
 * - getApiBase 必須 lazy:host plugin(提供 $getFastApiUrl)晚於 analytics plugin 執行
 */

import pkg from '../../../package.json'

import { useAuthToken } from '@/composables/auth/useAuthToken'
import { useUserInfo } from '@/composables/user/useUserInfo'
import { convCookies } from '@/utils/conversionCookies'
import { createConversionSender } from '@/utils/conversionSender'

export const useConversion = () => {
  const nuxtApp = useNuxtApp()

  if (!nuxtApp._conversionContext) {
    const { clientId, apiUrl, appSecret, runningEnv } = useRuntimeConfig().public
    const { token } = useAuthToken()
    const { userInfo } = useUserInfo()

    const sendConversionEvent = createConversionSender({
      getToken: () => token.value,
      getUserInfo: () => userInfo.value || {},
      getApiBase: () => nuxtApp.$getFastApiUrl?.() || apiUrl,
      site: clientId,
      appSecret,
      appVersion: pkg.version,
      isDevLike: ['dev', 'qa'].includes(runningEnv),
      fetchImpl: (...args) => fetch(...args),
      cookies: convCookies,
      getHref: () => window.location.href,
      getStoredUtmRaw: () => localStorage.getItem(`__umami_utm_${clientId}`),
      now: () => Math.floor(Date.now() / 1000),
    })

    const cleanup = () => {}

    nuxtApp._conversionContext = {
      sendConversionEvent,
      cleanup,
    }
  }

  return nuxtApp._conversionContext
}
